import { render, staticRenderFns } from "./MemoDetailView.vue?vue&type=template&id=399f1c54&"
import script from "./MemoDetailView.vue?vue&type=script&lang=js&"
export * from "./MemoDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports